import { Shield, Eye, Zap, HeartHandshake } from "lucide-react";
import { IMAGES } from "@/constants/assets";

const VALUES = [
  { icon: Shield, title: "Trust", desc: "Reliable, licensed, and accountable — always." },
  { icon: Eye, title: "Vigilance", desc: "Trained to stay alert and prevent before it happens." },
  { icon: Zap, title: "Response", desc: "Fast, decisive action when it matters most." },
  { icon: HeartHandshake, title: "Care", desc: "Professional, respectful service for every client." },
];

export default function About() {
  return (
    <div className="bg-[#000000] text-white">
      <section className="relative py-24 md:py-32 border-b border-white/8 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.heroSecurity} alt="Marco Polo Security officer" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-scrim" />
          <div className="absolute inset-0 grid-lines-navy opacity-40" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-condensed text-xs font-bold tracking-[0.28em] uppercase text-red-500 mb-3">— About Us</p>
          <h1 className="font-display font-black text-4xl md:text-6xl uppercase text-white leading-[1] text-balance max-w-3xl">
            Reliable Protection.<br />Delivered With Discipline<span className="text-red-500">.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-300 leading-relaxed max-w-3xl">
            Marco Polo Security provides reliable, professional, and highly trained security services throughout
            Washington State, with a strong focus on King County and Pierce County. Our team protects people,
            property, businesses, and events with dedication and care.
          </p>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="font-condensed text-xs font-bold tracking-[0.28em] uppercase text-red-500 mb-3">— Our Mission</p>
            <h2 className="font-display font-black text-3xl md:text-5xl uppercase leading-[1.05]">
              Peace of Mind,<br />at Every Hour.
            </h2>
            <p className="mt-6 text-slate-400 leading-relaxed">
              We offer dependable security solutions for businesses, residential properties, construction sites,
              private events, public events, commercial buildings, and mobile patrol needs. Whether you need
              daytime security, nighttime patrol, event protection, or mobile security coverage — Marco Polo
              Security is ready to help.
            </p>
            <p className="mt-4 text-slate-400 leading-relaxed">
              We believe security is not just about presence. It is about trust, responsibility, and quick action
              when it matters most.
            </p>
          </div>
          <div className="aspect-[4/5] rounded-sm overflow-hidden border border-white/10">
            <img src={IMAGES.officerInStore} alt="Marco Polo Security officer" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-24 border-t border-white/8 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-14">
            <p className="font-condensed text-xs font-bold tracking-[0.28em] uppercase text-red-500 mb-3">— Our Values</p>
            <h2 className="font-display font-black text-3xl md:text-5xl uppercase leading-[1.05]">What We Stand For</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {VALUES.map((v) => (
              <div key={v.title} className="group relative bg-[#141414]/60 border border-white/10 rounded-sm p-8 hover:border-red-500/50 transition-colors">
                <div className="absolute top-0 left-0 h-0.5 w-0 bg-red-600 group-hover:w-full transition-all duration-500" />
                <div className="w-11 h-11 rounded-sm bg-white/5 border border-white/10 flex items-center justify-center mb-4 group-hover:bg-red-600 group-hover:border-red-600 transition-colors">
                  <v.icon className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-condensed font-bold text-lg text-white uppercase tracking-wider">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
